import { Box, Typography } from '@mui/material';
import CustomProgressBar from 'src/components/custom-progress-bar/CustomProgressBar';
import styleVariables from 'src/scss/_variables.scss';
import {
  LEMONSQUEEZY_PAYMENT_LOADER_TEXT_TRANSLATION_KEY,
  LEMONSQUEEZY_PAYMENT_LOADER_SUBTEXT_TRANSLATION_KEY,
  LEMONSQUEEZY_PAYMENT_GUIDE_FOR_USERS,
  MUI_DRAWER_OVERRIDING_Z_INDEX,
} from 'src/constants/lemonsqueezy';
import { observer } from 'mobx-react-lite';
import { usePaymentStore } from 'src/stores/PaymentStore/PaymentStore';
import { CustomListItems } from 'src/components/custom-list-items/CustomListItemsMUIComponent';
import { useTranslation } from 'react-i18next';

const PaymentFlowLoader = observer(() => {
  const { isPaymentFlowStarted } = usePaymentStore();
  const { t } = useTranslation();

  if (!isPaymentFlowStarted) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        left: '0',
        top: '0',
        width: '100vw',
        height: '100vh',
        zIndex: MUI_DRAWER_OVERRIDING_Z_INDEX,
        backgroundColor: styleVariables.darkNavyBlue,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          height: '100vh',
        }}
      >
        <CustomProgressBar
          title={t(LEMONSQUEEZY_PAYMENT_LOADER_TEXT_TRANSLATION_KEY)}
          progressBarWrapperStyle={{
            padding: '20px 40px',
            backgroundColor: styleVariables.hanabiThemeColorDarkRed,
            borderRadius: '8px',
            border: '4px solid',
            borderColor: styleVariables.colorWhite,
          }}
        />
        <Typography
          sx={{ marginTop: '16px', color: styleVariables.colorWhite }}
        >
          {t(LEMONSQUEEZY_PAYMENT_LOADER_SUBTEXT_TRANSLATION_KEY)}
        </Typography>
        <CustomListItems
          listItemsData={LEMONSQUEEZY_PAYMENT_GUIDE_FOR_USERS}
          listItemStyle={{
            listStyleType: 'disc',
            marginLeft: '16px',
            color: styleVariables.colorWhite,
            padding: 0,
          }}
        />
      </Box>
    </Box>
  );
});

export default PaymentFlowLoader;
